(function ($) {
    $(document).ready(function () {
        var supress = $(".IconHomepage").data("supress-content");
        if (supress == "True") {
            $("#content .component").not(".IconHomepage").addClass("supress");
        }

    });
}(window.jQuery));

//Analytics for Icon Homepage
analytics.eventConfig.push({
    "target": ".component.IconHomepage",
    "codeId": "ih",
    "events": [
        {
            "eventTarget": "a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "ih",
                "componentName": "icon homepage",
                "destinationUrl": "",
                "fileName": "",
                "elementText": "",
                "elementType": "icon homepage link",
                "event": [

                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "outbound click"
                    }
                ],
            }
        },
        {
            "eventTarget": "a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "ih",
                "componentName": "icon homepage",
                "destinationUrl": "",
                "elementText": "",
                "fileName": "",
                "elementType": "icon homepage link",
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf')!== -1 || $(context).attr('href').toLowerCase().search('xls')!== -1 || $(context).attr('href').toLowerCase().search('xlsx')!== -1 || $(context).attr('href').toLowerCase().search('doc')!== -1 || $(context).attr('href').toLowerCase().search('docx')!== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "icon homepage internal navigation click"
                    }
                ],
            }
        }
    ]
});